<template>
    <v-touch v-on:swiperight="swiperRight" class="wrapper">
    <div id="app">


            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"/>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"/>

    </div>
    </v-touch>
</template>
<script>
    export default {
        // 刷新
        name: 'app',
        provide() {
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                isRouterAlive: true,
            }
        },
        methods: {
            reload() {
                this.isRouterAlive = false;
                this.$nextTick(function () {
                    this.isRouterAlive = true;
                })
            },
            swiperRight() {
                this.$router.go(-1);
            },
            iosAuroraPush(content){//ios监听到极光推送的方法
              this.$router.push(
                  {path:'/jgmessage',query:{'message':content}
            })
         }
        },mounted (){
             window.iosAuroraPush = this.iosAuroraPush;
        },
    }
</script>
<style lang="less">
    @bule-thame: #3C6EEB;
    body {
        background: #f7f7ff;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        .van-nav-bar {
            background-color: @bule-thame;
            i,
            .van-nav-bar__title,
            .van-nav-bar__text {
                color: #fff;
            }

            .jump-nav-bar-rhd {
                color: #fff;
                font-size: 16px;
                i {
                    font-size: 18px;
                }
                span {
                    margin-left: 10px;
                }
            }
        }
        .van-tabbar {
            i {
                font-size: 16px;
            }
        }
        .van-tabs__line {
            background-color: @bule-thame;
        }
        strong img {
            width: 100%;
        }
        input {
            outline-style: none;
            border-radius: 3px;
            //padding: 3px 3px;
            font-family: "Microsoft soft";
        }
        .gooddetail img {
            width: 100%;
            height: auto;
        }
    }

</style>
